customElements.get("quick-add-to-cart") || customElements.define("quick-add-to-cart", class extends HTMLElement {
  constructor() {
    super(), this.viewLayout = null, this.tabletMQ = null, this.addToCartController = null, 
    this.currentOperation = null, this.enableLogging = "true" === this.getAttribute("data-enable-logging"), 
    this.viewLayoutElements = this.closest(".shopify-section").querySelectorAll('input[name="product-card-view"]'), 
    this.form = this.querySelector("form"), this.buttonEl = this.querySelector('button[type="submit"]'), 
    this.handleSubmit = this.handleSubmit.bind(this), this.handleInputChange = this.handleInputChange.bind(this), 
    this.handleLayoutChange = this.handleLayoutChange.bind(this), this.updateButton = this.updateButton.bind(this), 
    this.setupDesktop = this.setupDesktop.bind(this), this.setupTablet = this.setupTablet.bind(this);
  }
  log(...t) {
    this.enableLogging && console.log("[QuickAddToCart]", ...t);
  }
  async cancelPreviousAddToCart() {
    if (this.addToCartController && (this.addToCartController.abort(), this.currentOperation)) try {
      await this.currentOperation;
    } catch (t) {
      this.log("Previous operation aborted:", t.name);
    }
    this.addToCartController = new AbortController;
  }
  updateButton() {
    if (!this.buttonEl) return;
    const t = this.buttonEl.querySelector("span.pc-qatc-add-long");
    if (!t) return;
    const e = this.form.querySelector("input:checked"), i = this.form.querySelector(".product-card__qatc-options"), a = i && !i.hasAttribute("data-quick-add-to-cart-hidden");
    e ? (this.buttonEl.removeAttribute("disabled"), t.textContent = window.strings?.addToCart || "Add to Cart") : a ? (this.buttonEl.setAttribute("disabled", "true"), 
    t.textContent = window.strings?.selectOptions || "Select options") : (this.buttonEl.removeAttribute("disabled"), 
    t.textContent = window.strings?.addToCart || "Add to Cart");
  }
  async handleSubmit(t) {
    t.preventDefault(), await this.cancelPreviousAddToCart();
    try {
      this.currentOperation = window.Shopify.addToCart(this.form, {
        signal: this.addToCartController.signal
      }), await this.currentOperation, "two" !== this.viewLayout && this.form.reset();
    } catch (t) {
      "AbortError" !== t.name ? console.error("Quick add submission failed:", t) : this.log("Submit operation was aborted");
    } finally {
      this.currentOperation = null, this.updateButton();
    }
  }
  async handleInputChange(t) {
    if ("two" !== this.viewLayout) {
      await this.cancelPreviousAddToCart();
      try {
        this.currentOperation = window.Shopify.addToCart(this.form, {
          signal: this.addToCartController.signal
        }), await this.currentOperation, this.form.reset();
      } catch (t) {
        "AbortError" !== t.name ? console.error("Quick add on input change failed:", t) : this.log("Input change operation was aborted");
      } finally {
        this.currentOperation = null, this.updateButton();
      }
    } else this.updateButton();
  }
  async handleLayoutChange(t) {
    await this.cancelPreviousAddToCart(), this.viewLayout = t.target.value, this.form.reset(), 
    this.updateButton();
  }
  setupDesktop() {
    this.viewLayoutElements.length && this.viewLayoutElements.forEach(t => {
      t.checked && (this.viewLayout = t.value), t.addEventListener("change", this.handleLayoutChange);
    });
  }
  setupTablet() {
    this.viewLayout = null, this.viewLayoutElements.length && this.viewLayoutElements.forEach(t => t.removeEventListener("change", this.handleLayoutChange));
  }
  connectedCallback() {
    if (!this.form) return;
    this.addToCartController = new AbortController, this.tabletMQ = window.matchMedia("(max-width: 1024px)"), 
    this.tabletMQ.matches ? this.setupTablet() : this.setupDesktop(), this.tabletMQ.addEventListener("change", t => {
      t.matches ? this.setupTablet() : this.setupDesktop();
    });
    const t = this.form.querySelector("input[checked]");
    t && (t.checked = !1, t.removeAttribute("checked")), this.form.addEventListener("submit", this.handleSubmit), 
    this.hasAttribute("data-change-submit") && this.form.addEventListener("input", this.handleInputChange), 
    this.updateButton();
  }
  disconnectedCallback() {
    this.addToCartController && this.addToCartController.abort(), this.form.removeEventListener("submit", this.handleSubmit), 
    this.hasAttribute("data-change-submit") && this.form.removeEventListener("input", this.handleInputChange), 
    this.viewLayoutElements.length && this.viewLayoutElements.forEach(t => t.removeEventListener("change", this.handleLayoutChange));
  }
});